var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.9998,
    cy: 34,
    r: 28.3333,
    fill: "#3DB080"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6236 41.5364L23.1324 34.0762L20.9678 36.5639L29.6236 46.5089L48.1678 25.1965L46.0031 22.7089L29.6236 41.5364Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessMark);
export default __webpack_public_path__ + "static/media/successMark.b65c6b9902cec9cf8f1c84f7174f5bd5.svg";
export { ForwardRef as ReactComponent };